export enum PolicyEditViewContext {
    NEW = 'NEW',
    COPY_DRAFT = 'COPY_DRAFT',
    EDIT_DRAFT = 'EDIT_DRAFT',
}
